import type { MedicalOrganization, WithContext } from 'schema-dts';

export const buildHomePageJsonLd = (pageUrl: string): WithContext<MedicalOrganization> => ({
  '@context': 'https://schema.org',
  '@type': 'MedicalOrganization',
  '@id': pageUrl,
  name: "Children's Wisconsin",
  description:
    "Children's Wisconsin is the region's only independent health system dedicated solely to the health and well-being of children.",
  logo: 'https://edge.sitecorecloud.io/childrensho3e59-cw60b4-prod2126-77fc/media/Feature/CW/CWPageContent/Childrens-Wisconsin-Logo.svg',
  url: pageUrl,
  mainEntityOfPage: pageUrl,
  telephone: '+1-414-266-2000',
  medicalSpecialty: 'https://schema.org/Pediatric',
  isAcceptingNewPatients: true,
  nonprofitStatus: 'https://schema.org/Nonprofit501c3',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '8915 W Connell Ct',
    addressLocality: 'Milwaukee',
    addressRegion: 'WI',
    postalCode: '53226',
  },
});
